import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';

import { toastError, toastSuccess } from '@components/Toast';

import ApiClient from '@lib/apiClient';

const AddDepartment = ({ show, setShow, callback }) => {
	const [detpartmentName, setDepartmentName] = useState('');
	const [userTypes, setUserTypes] = useState([]);
	const [description, setDescription] = useState('');
	const [userTypeList, setUserTypeList] = useState([]);
	const [error, setError] = useState({});

	const handleClose = () => {
		setShow(false);
	};

	const validateForm = () => {
		let cloneError = { ...error };
		if (!detpartmentName) {
			cloneError.detpartmentName = 'Department name is required';
		}
		if (userTypes.length === 0) {
			cloneError.userTypes = 'User type name is required';
		}
		setError(cloneError);

		return Object.keys(cloneError).length > 0;
	};

	const addDepartmentInfo = () => {
		if (!validateForm()) {
			let postObj = {
				name: detpartmentName,
				description: description,
				userTypeSet: userTypes.map((userType) => userType.value)
			};

			ApiClient.POST('addDepartment', postObj)
				.then(() => {
					callback();
					setShow(false);
					toastSuccess('Successfully added');
					setDepartmentName('');
					setUserTypes([]);
					setDescription('');
				})
				.catch(() => {
					toastError('Something went wrong!');
				});
		}
	};

	useEffect(() => {
		ApiClient.GET('getUserTypesWithBuyer').then(({ data }) => {
			setUserTypeList(data);
		});
	}, []);

	return (
		<>
			<Modal className="add-department-popup" show={show} onHide={handleClose} centered>
				<div className="common-popup">
					<Modal.Header closeButton>
						<h3 className="semibold-16 mb-0">Add Department</h3>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="container px-0">
								<div className="row">
									<div className="col-md-12">
										<div className="form-group">
											<label htmlFor="departmentName">Department name*</label>
											<input
												type="text"
												autoComplete="off"
												id="departmentName"
												onChange={(e) => setDepartmentName(e.target.value)}
											/>
											{error.detpartmentName && (
												<p className="error">{error.detpartmentName}</p>
											)}
										</div>
									</div>

									<div className="col-md-12">
										<div className="form-group no-shadow-react-select">
											<label htmlFor="userType">User type*</label>
											<Select
												onChange={setUserTypes}
												value={userTypes}
												isMulti
												options={userTypeList}
											/>
											{error.userTypes && <p className="error">{error.userTypes}</p>}
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-0">
											<label>Description</label>
											<textarea
												cols="30"
												rows="3"
												name="address"
												placeholder="Write remarks"
												onChange={(e) => setDescription(e.target.value)}
											></textarea>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button className="button size32 ml-2" onClick={addDepartmentInfo}>
							Submit
						</button>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);
};

export default AddDepartment;
